import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../../APIHelpers/Responses";

export const eiwrsKitBatchNumberServices = {
  //Batch Number Metadata
  addNewEIWRSKitBatchNumberMetadata,
  updateEIWRSKitBatchNumberMetadataData,
  deleteEIWRSKitBatchNumberMetadataData,
  softDeleteRestoreEIWRSKitBatchNumberMetadata,
  getEIWRSKitBatchNumberMetadataData,
};

// Add New Kit Batch Number Metadata
async function addNewEIWRSKitBatchNumberMetadata(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewEIWRSKitBatchNumberMetadata`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Kit Batch Number Metadata
async function updateEIWRSKitBatchNumberMetadataData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateEIWRSKitBatchNumberMetadataData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Kit Batch Number Metadata
async function softDeleteRestoreEIWRSKitBatchNumberMetadata(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreEIWRSKitBatchNumberMetadata`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Kit Batch Number Metadata
async function deleteEIWRSKitBatchNumberMetadataData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteEIWRSKitBatchNumberMetadataData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Kit Batch Number Metadata
async function getEIWRSKitBatchNumberMetadataData(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEIWRSKitBatchNumberMetadataData/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEIWRSKitBatchNumberMetadataData/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}